import React from "react";
import { BusinessCreditReportStatePII, IActiveLawSuite } from "../../../../store/businessCreditReportService/types";
import { toggle } from "../../../../util/common";

interface IProps {
    reportObject: BusinessCreditReportStatePII;
    showAsAccordion?: boolean;
}
const LegalFilingsActiveLawsuits: React.FunctionComponent<IProps> = (props) => {
    return (
        <React.Fragment>
            <div role="listitem" className="data-row">
                <div className="link-item">
                    {props.showAsAccordion ? (
                        <button
                            type="button"
                            aria-expanded="false"
                            className="link-button"
                            id="btn-leagal-filings-active-lawsuits"
                            onClick={(e) => toggle("leagal-filings-active-lawsuits-div", "btn-leagal-filings-active-lawsuits")}
                        >
                            <span className="row link-item">
                                <span className="col-xs col-no-gutter link-text">
                                    <span className="link-title">
                                        <span className="btn-toggle-status sr-only">Show</span> Active Lawsuits
                                    </span>
                                </span>
                            </span>
                        </button>
                    ) : (
                        <h5 className="report-sub-title">Active Lawsuits</h5>
                    )}

                    <div
                        className="wallet-details"
                        id="leagal-filings-active-lawsuits-div"
                        style={{ ...(props.showAsAccordion ? { display: "none" } : {}) }}
                        aria-hidden="true"
                    >
                        {props.reportObject?.businessCompanyReport?.active_law_suites?.map((activeLawsuite: IActiveLawSuite, index: number) => (
                            <React.Fragment key={`active-lawsuite-${index}`}>
                                <div role="grid" className="data-grid row-height-xs " aria-labelledby="btn-leagal-filings-active-lawsuits">
                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={`leagal-filings-active-lawsuits-date-filed-${index}`}>
                                                Date Filed
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={`leagal-filings-active-lawsuits-filing-type-${index}`}>
                                                Filing Type
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={`leagal-filings-active-lawsuits-case-number-${index}`}>
                                                Case Number
                                            </div>
                                        </div>
                                    </div>

                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-value" aria-labelledby={`leagal-filings-active-lawsuits-date-filed-${index}`}>
                                                {activeLawsuite?.date_filed}
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-value" aria-labelledby={`leagal-filings-active-lawsuits-filing-type-${index}`}>
                                                {activeLawsuite?.filing_type}
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-value" aria-labelledby={`leagal-filings-active-lawsuits-case-number-${index}`}>
                                                {activeLawsuite?.case_number}
                                            </div>
                                        </div>
                                    </div>

                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={`leagal-filings-active-lawsuits-amount-${index}`}>
                                                Amount
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={`leagal-filings-active-lawsuits-plaintiff-${index}`}>
                                                Plaintiff
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={`leagal-filings-active-lawsuits-blank-${index}`}></div>
                                        </div>
                                    </div>

                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-value" aria-labelledby={`leagal-filings-active-lawsuits-amount-${index}`}>
                                                {activeLawsuite?.amount}
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-value" aria-labelledby={`leagal-filings-active-lawsuits-plaintiff-${index}`}>
                                                {activeLawsuite?.plaintiff}
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-value" aria-labelledby={`leagal-filings-active-lawsuits-blank-${index}`}></div>
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default LegalFilingsActiveLawsuits;
